import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function AssignNotification() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [navFormData, setNavFormData] = useState([]);
  const [triggerRerender, setTriggerRerender] = useState(false);
  const [clearRows, setClearRows] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      centerId: "",
    },
  });

  const [classesData, setClassesData] = useState([]);
  const [EmailTamplateData, setEmailTamplateData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedCenterIds, setSelectedCenterIds] = useState(
    savedCenterId || null
  );
  const [selectedAssignBtnIds, setselectedAssignBtnIds] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [AssignAlertSelectError, setAssignAlertSelectError] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [selectedFormId, setSelectedFormId] = useState("");
  const [alertNotificationButton, setAlertNotificationButton] = useState([]);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);
        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
            getAllClassesList(selectedCenter.id);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
    const fetchEmailData = async () => {
      try {
        const response = await get(
          `AlertManager/GetEmailTamplateDropdown?CenterId=${savedCenterId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEmailTamplateData(response.alertEmailData);
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };
    fetchEmailData();
  }, [setValue, triggerRerender, savedCenterId]);
  const getNavFormList = async (subCategoryId) => {
    if (!token || !subCategoryId) return;
    try {
      const formdata = { id: subCategoryId };
      const response = await post(
        `UserAuthentication/GetAllNavForm`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setNavFormData(response);
    } catch (error) {
      console.error("Error fetching nav forms:", error);
    }
  };
  const getAllClassesList = async (centerId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Class/AssignedClasssesToCenter?centerId=${centerId}&&organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setClassesData(response);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const handleEditClick = async (rowId) => {
    var formData = { id: rowId };
    try {
      const response = await post(
        `UserAuthentication/GetNavFormById`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const selectedNavForm = response;

      const selectedCategory = categoryData.find(
        (option) => option.id === response.subCategoryFormId
      );

      const selectedSubCategory = subCategoryData.find(
        (option) => option.id === response.formSubCategoriesId
      );

      reset({
        id: selectedNavForm.id,
        name: selectedNavForm.name,
        formPath: selectedNavForm.formPath,
        formCategoryId: selectedCategory
          ? { value: selectedCategory.id, label: selectedCategory.name }
          : null,
        FormSubCategoriesId: selectedSubCategory
          ? { value: selectedSubCategory.id, label: selectedSubCategory.name }
          : null,
      });

      setSelectedCategoryId(selectedCategory?.id || "");
      setSelectedSubCategoryId(selectedSubCategory?.id || "");
    } catch (error) {
      console.error("Error fetching navform:", error);
    }
  };
  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Form?"
    );

    if (confirmDelete) {
      const formdata = { id: rowId };
      try {
        const response = await post(
          `UserAuthentication/DeleteNavForm`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        getNavFormList(selectedSubCategoryId);
      } catch (error) {
        console.error("Error deleting navform:", error);
      }
    }
  };
  const fetchAlertNotificationButton = async (emailTamplateId, formId) => {
    try {
      const response = await get(
        `AlertManager/GetAssignAlertManagerEmailForm?EmailTemplateId=${emailTamplateId}&FormId=${formId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAlertNotificationButton(response.assignAlertManager);
    } catch (error) {
      console.error("Error fetching notificationType:", error);
    }
  };
  const columns = [
    { name: "Sr No.", selector: (row, rowIndex) => rowIndex + 1 },

    {
      name: "Name",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
  ];
  const handleCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`formCategoryId`, null);
      setSelectedCategoryId("");
      setSelectedSubCategoryId(null); // Reset subcategory only if category is cleared
    } else {
      setValue(`formCategoryId`, selectedOption || { value: 0, label: "" });
      setSelectedCategoryId(selectedOption?.value);
    }
    trigger(`formCategoryId`);
  };
  const getCategories = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    getCategories();
  }, [triggerRerender]);
  useEffect(() => {
    if (selectedCategoryId) {
      getSubCategoryList(selectedCategoryId);
    } else {
      setSubCategoryData([]);
    }
  }, [selectedCategoryId, triggerRerender]);
  useEffect(() => {
    if (selectedSubCategoryId) {
      getNavFormList(selectedSubCategoryId);
    } else {
      setNavFormData([]);
    }
  }, [selectedSubCategoryId, triggerRerender]);
  const getSubCategoryList = async (categoryId) => {
    if (!token || !categoryId) return;
    try {
      const formdata = { formCategoryId: categoryId };
      const response = await post(
        `UserAuthentication/GetAllNavSubCategory`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubCategoryData(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };
  const handleSubCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`FormSubCategoriesId`, null);
      setSelectedFormId(null);
    } else {
      setValue(
        `FormSubCategoriesId`,
        selectedOption || { value: 0, label: "" }
      );
      setValue(`FormId`, null);
      setSelectedSubCategoryId(selectedOption?.value);
    }
    trigger(`FormSubCategoriesId`);
  };
  const handleFormChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`FormId`, null);
      setSelectedFormId(null);
    } else {
      setValue(`FormId`, selectedOption || { value: 0, label: "" });
      const formId = getValues(`FormId`) ? getValues(`FormId`).value : null;
      const emailTemplateId = getValues(`emailTamplateId`)
        ? getValues(`emailTamplateId`).value
        : null; // Safely access the email template ID
      //   setSelectedSubCategoryId(selectedOption?.value);
      fetchAlertNotificationButton(emailTemplateId, formId);
    }
    trigger(`FormId`);
  };
  const handleEmailTamplateChange = (selectedOption, actionMeta) => {
    const formId = getValues(`formId`) ? getValues(`formId`).value : null;
    const emailTemplateId = getValues(`emailTamplateId`)
      ? getValues(`emailTamplateId`).value
      : null; // Safely access the email template ID
    //   setSelectedSubCategoryId(selectedOption?.value);
    fetchAlertNotificationButton(emailTemplateId, formId);
  };
  const onCenterSelect = (selectedCenter) => {
    setSelectedCenterIds(selectedCenter.value);
  };
  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => ({
      id: row.alertManagerButtonId,
      status: true,
    }));

    const unselectedRows = alertNotificationButton
      .filter(
        (row) => !state.selectedRows.some((selected) => selected.id === row.id)
      )
      .map((row) => ({
        id: row.id,
        status: false,
      }));

    // Combine selected and unselected rows
    const updatedRows = [...selectedRows, ...unselectedRows];
    setselectedAssignBtnIds(updatedRows);
  };
  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (selectedAssignBtnIds.length === 0) {
      setAssignAlertSelectError("Please select.");
      return;
    } else {
      setAssignAlertSelectError("");
    }
    // Collecting selected alert notification buttons and their statuses
    // Collecting selected alert notification buttons and their statuses
    const selectedRows = selectedAssignBtnIds.map((row) => ({
      AlertManagerButtonId: row.id,
      Status: row.status,
    }));

    const formData = {
      FormId: data.FormId?.value,
      ControllerId: data.ControllerId?.value,
      EmailTamplateId: data.emailTamplateId?.value,
      AlertNotifications: selectedRows,
    };

    try {
      const response = await post(
        "AlertManager/SaveAssignAlertManagerEmailForm",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success("Success!");
        getAllClassesList(selectedCenterIds);
        // reset({
        //   id: 0,
        //   emailTamplateId: "",
        //   formCategoryId: "",
        //   FormSubCategoriesId: "",
        //   FormId: "",
        // });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Alert Notification</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            onCenterSelect(selectedOption);
                            getAllClassesList(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={
                          savedCenterId !== null && savedCenterId !== 0
                        }
                      />
                    )}
                  />

                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Select Email Template
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="emailTamplateId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={EmailTamplateData.map((emailData) => ({
                          value: emailData.id,
                          label: emailData.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`emailTamplateId`, null);
                          } else {
                            setValue(
                              `emailTamplateId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`emailTamplateId`);
                          handleEmailTamplateChange(selectedOption, actionMeta);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={
                          savedCenterId !== null && savedCenterId !== 0
                        }
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`formCategoryId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={categoryData.map((category) => ({
                          value: category.id,
                          label: category.name,
                        }))}
                        onChange={handleCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.formCategoryId && (
                    <small className="text-danger">
                      {errors.formCategoryId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Sub Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`FormSubCategoriesId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subCategoryData.map((subCategory) => ({
                          value: subCategory.id,
                          label: subCategory.name,
                        }))}
                        onChange={handleSubCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.FormSubCategoriesId && (
                    <small className="text-danger">
                      {errors.FormSubCategoriesId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Form<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`FormId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={navFormData.map((form) => ({
                          value: form.id,
                          label: form.name,
                        }))}
                        onChange={handleFormChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.FormSubCategoriesId && (
                    <small className="text-danger">
                      {errors.FormSubCategoriesId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={alertNotificationButton}
                pagination
                dense
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
                clearSelectedRows={clearRows}
                selectableRowSelected={useMemo(
                  () => (row) => row.status === true, // Automatically check rows with status 1
                  [alertNotificationButton]
                )}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
export default AssignNotification;
